<template>    
  <div>
    <v-main>
      <v-container>
        <router-link :to="`/${route}`">
          &lt;&lt; {{ $t("voltar") }}
        </router-link>
        <v-row>
          <v-col>
            <div class="text-h4">
              {{ $t("nAbreviado") }} {{ salesQuote }}
            </div>
          </v-col>
        </v-row>
        <v-skeleton-loader
          v-if="loading"
          :loading="loading"
          transition="fade-transition"
          type="table"
        />
        <v-card v-show="!loading">
          <v-container>
            <v-row class="pa-1">
              <AppDetailLabel
                :title="$t('cliente')"
                :value="quote.CUSTOMER_NAME"
                :md="4"
              />
              <AppDetailLabel
                :title="$t('ordemCompra')"
                :value="quote.CUST_PO_NUMBER"
                :md="4"
              />
              <AppDetailLabel
                :title="$t('repVendas')"
                :value="quote.SALES_REP_NAME"
                :md="4"
              />
              <AppDetailLabel
                :title="$t('dataDesejada')"
                :value="dateToUSNoHour(quote.REQUEST_DATE)"
                :md="4"
              />
              <AppDetailLabel
                :title="$t('dataPedido')"
                :value="dateToUSNoHour(quote.CREATION_DATE)"
                :md="4"
              />
              <AppDetailLabel
                :title="$t('totalOrdem')"
                :value="currencyUSA(quote.TOTAL, 2)"
                :md="4"
              />
              <AppDetailLabel
                :title="$t('tipoFrete')"
                :value="listFreight[quote.FREIGHT_TERMS]"
                :md="4"
              />
              <AppDetailLabel
                :title="$t('tipoPedido')"
                :value="quote.TYPE_DESCRIPTION"
                :md="4"
              />
              <v-col
                :cols="4"
                class="pa-0"
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>{{ $t('status') }}</v-list-item-subtitle>
                    <v-list-item-title>
                      <div v-if="quote.STATUS === 'A'">
                        <v-chip
                          v-for="status in statusQuote"
                          v-show="status.id === quote.ID_IMPORTACAO"
                          :key="status.id"
                          :color="status.class"
                          style="margin-right: 1px;"
                          text-color="white"
                          x-small
                        >
                          <span>{{ status.name }}</span>
                        </v-chip>
                      </div>
                      <div v-else-if="quote.STATUS === 'R'">
                        <v-chip
                          color="error"
                          style="margin-right: 1px;"
                          text-color="white"
                          x-small
                        >
                          <span>{{ $t('reprovado') }}</span>
                        </v-chip>
                      </div>
                      <div v-else>
                        <v-chip
                          color="grey"
                          style="margin-right: 1px;"
                          text-color="white"
                          x-small
                        >
                          <span>{{ $t('pendente') }}</span>
                        </v-chip>
                      </div>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider />
              </v-col>
              <AppDetailLabel
                :title="$t('dataImportacao')"
                :value="quote.DT_IMPORTACAO"
                :md="4"
              />
              <AppDetailLabel
                :title="$t('numPedImportado')"
                :value="quote.CD_PEDIDO_VENDA_OI"
                :md="4"
              />
              <AppDetailLabel
                :title="$t('logImportacao')"
                :value="quote.DS_LOG_IMPORTACAO"
                :md="4"
              />
              <AppDetailLabel
                :title="$t('observacoes')"
                :value="quote.DS_OBSERVACAO"
                :md="12"
                :hidden-divider="true"
              />
            </v-row>
          </v-container>
        </v-card>
        <br>
        <v-card v-if="listQuotesItems">
          <v-container>
            <v-data-table
              :headers="headers"
              :items="listQuotesItems"
              :search="search"
              :sort-by.sync="sortyBy"
              :sort-desc.sync="sortyDesc"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:no-data>
                {{ $t("naoHaDadosDisponiveis") }}
              </template>
              <template v-slot:top>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  :label="$t('filtro')"
                  class="mx-4"
                />
              </template>
              <template v-slot:item.SALE_PRICE="{ item }">
                <div>
                  {{ item.SALE_PRICE | currencyUSA(4) }}
                </div>
              </template>
              <template v-slot:item.TOTAL="{ item }">
                <div>
                  {{ item.SALE_PRICE * item.PRODUCT_QUANTITY | currencyUSA(4) }}
                </div>
              </template>
            </v-data-table>
          </v-container>
        </v-card>
        <br>
      </v-container>
    </v-main>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import AppDetailLabel from "../../components/generic/AppDetailLabel";
import { currencyUSA, dateToUSNoHour } from "../../helpers/filter";
import EventBus from "../../plugins/event-bus";

const route = "quotes";
const appStore = "AppQuotesStore"; 

export default {
  components: {
    AppDetailLabel
  },
  props: {
    salesQuote: {
      type: String,
      default: ""
    },
  },
  data () {
    return {
      loading: true,
      search: "",
      sortyBy: "PRODUCT_CODE",
      sortyDesc: false,
      route: route,
      listFreight: {
        'Prepay & Add': 'Prepay and Add',
        'Prepaid': 'Prepaid',
        'Customer has responsability on Freight': 'Will Call',
        'Collect': 'Use Customer Shipping Account'
      },
      statusQuote: [
        { id: 'N', name: this.$i18n.t("naoImportado"), class: "warning" },
        { id: 'Y', name: this.$i18n.t("importado"), class: "primary" },
        { id: 'E', name: this.$i18n.t("erroImportacao"), class: "error" },
        { id: 'R', name: this.$i18n.t("cotacao"), class: "purple" },
        { id: 'L', name: this.$i18n.t("importando"), class: "grey" }
      ],
      headers: [
        { text: this.$i18n.t("numeroPeca"), value: "PART_NUMBER" },
        { text: this.$i18n.t("codigoTigre"), value: "PRODUCT_CODE" },
        { text: this.$i18n.t("produto"), value: "DESCRIPTION" },
        { text: this.$i18n.t("quantidade"), value: "PRODUCT_QUANTITY" },
        { text: this.$i18n.t("precoUnit"), value: "SALE_PRICE", sortable: false },
        { text: this.$i18n.t("total"), value: "TOTAL", sortable: false }
      ]
    }
	},
  computed: {
    ...mapState(appStore, {
      listQuotesItems: (state) => state[`items`],
      quote: state => state.quote
    })
  },
	created() {
    EventBus.$on("change::isLoading", (loading) => {
      this.loading = loading;
    });
  },
  mounted() {
    this.$store.commit(`${appStore}/cleanState`);
    this.$store.dispatch(`${appStore}/getById`, this.salesQuote);
  },
  methods: {
    currencyUSA,
    dateToUSNoHour,
    ...mapActions([`${appStore}/getById`]),
  }
}
</script>